import React, { useEffect, useState } from 'react';
import { IntlShape } from 'react-intl';
import styled from 'styled-components';
import { Grid } from '@material-ui/core';
import { get, isEmpty, isNil } from 'lodash';
import { Listings } from 'containers/AppContainer/typings';
import { KeycloakUser } from 'containers/RecapManagerPage/typings';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { PROVISION_TAB_LABELS } from 'containers/CourtManagerLegalProceedings/constants';
import useCollapse from 'hooks/useCollapse';
import DialogFeeNote from 'components/DialogFeeNote';
import RegulationRecapContainer from 'containers/CourtManagerLegalProceedings/Provision/Regulation/RegulationRecapContainer';
import { translate } from 'containers/services/translate';
import messages from 'containers/LawyerRecapPage/messages';
import ClaimRecap from 'containers/RecapManagerPage/ValidatedRecapClaim/ClaimRecap';
import ImagineDocumentsDrawer from 'containers/CourtManagerLegalProceedings/ImagineDocuments';
import { resolveSagisClaim } from 'helpers/utils';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import TrackingActionDrawer from 'containers/CourtManagerLegalProceedings/TrackingActionDrawer';
import ProvisionContainer from 'containers/CourtManagerLegalProceedings/Provision';
import CoreButton from 'components/Buttons/CoreButton';
import { ClaimRecapType } from 'typings/claimTypes';
import {
  claimTabs,
  filterFeeNotes,
} from 'containers/CourtManagerLegalProceedings/utils';
import { TopCard } from 'containers/CourtManagerLegalProceedings/TopCard';
import GlobalLegalProceedingTabs from 'components/GlobalLegalProceedingTabs';
import LegalProceedingTabs from 'components/LegalProceedingTabs';
import SuspiciousCard from 'containers/CourtManagerLegalProceedings/SuspiciousCard';

export interface ValidatedRecapClaimProps {
  intl: IntlShape;
  listings: Listings;
  storedClaimToPreopen: any;
  claimId: number;
  requestClaimRecap: Function;
  match: { params: { claimId: number } };
  claimRecap: ClaimRecapType;
  policyInfo: { sagis: {} };
  requestSearchClaims: Function;
  resetSearchClaimsStore: Function;
  setClaimRecap: Function;
  requestRejectClaim: Function;
  requestOpenClaim: Function;
  requestAssigment: Function;
  requestCorporealLawyers: Function;
  requestOpenMixedClaim: Function;
  corporealLawyers: KeycloakUser[];
  openedClaim: any;
  requestUpdateVictimInfo?: Function;
  requestCreateVehicle?: Function;
  requestValidateVictim?: Function;
  requestValidateVehicle: Function;
  requestAddVictims?: Function;
  requestUpdateVehicleInfo: Function;
  requestUpdateClaim?: Function;
  resetUploadDocumentStore?: Function;
  uploadDocument?: Function;
  uploadedDocument: IUploadedDocument;
  setDocumentId?: Function;
  documentId: string;
  requestAddDocumentClaim?: Function;
  requestValidateProvisionIntervenant?: Function;
  requestUnlockClaim: Function;
  requestLockClaim: Function;
  setLockedClaim: Function;
  resetStoreClaim: Function;
  foundClaims: any;
  requestAddClaimNumber: Function;
  feeNotes: any;
  loaders: any;
  requestGetFeeNotesByClaimId: Function;
  allFeeNote: any;
  feeNotesCount: any;
  linkToBeneficiaryCodes: any;
  requestAddInvoiceFeeNote: Function;
  makeDecisionFeeNote: Function;
  requestFeeNoteExceptionalCosts: Function;
  requestAllFeeNotes: Function;
  requestUpdateFeeNoteAmount: Function;
  requestUpdateFeeNoteStatus: Function;
  requestUpdateInvoiceFeeNote: Function;
  requestCreateFeeNote: Function;
  requestFeeNotesByClaimNumb: Function;
  dataClaimToUpdate: any;
  setDataClaimToUpdate: Function;
  sagisClaim: any;
  requestSagisClaimInfo: Function;
  requestSetStatusClaimSagis: Function;
  userActions: any;
  claimHistorySagis: any;
  setCurrentInstanceTab: Function;
  requestCreateStakeHolder: Function;
  regulations: any;
  requestCreateFeeNoteManager: Function;
  openFeeNoteDialog: any;
  setOpenFeeNoteDialog: Function;
  requestGetReportsPolicy: Function;
  requestGetPendingTasksClaim: Function;
  pendingTasksClaim: any;
  requestMakeDecisionsDocumentImaging: Function;
  requestGetNotificationsInboxes: Function;
  requestGetClaimHistoryActions: Function;
  requestGetClaimHistorySagis: Function;
  requestUploadDocumentManager: Function;
  requestGetDocByDocumentumId: Function;
  requestUpdateFirmReferenceManager: Function;
  imagineNotification: any;
}

export const Container = styled.main`
  .contester-button {
    margin-right: 20px;
  }
  background-color: transparent;
  margin-top: 80px;
  .subContainer {
    justify-content: space-around;
    margin-top: 0px;
  }

  .errorSelect {
    margin-top: 9px;
    color: red;
  }
`;
export const StyledButton = styled(CoreButton)`
  margin-top: 10px;
  margin-bottom: 20px;
  width: 300px;
  height: 40px;
  background: #ffc912;
  &:hover {
    background-color: #ffc912;
  }
`;
export const ValidatedRecapClaim: React.FC<ValidatedRecapClaimProps> = (
  props,
): JSX.Element => {
  const [dropDown, setDropDown] = React.useState<null | HTMLElement>(null);
  const [isDrawerOpen, setDrawerOpen] = React.useState(false);
  const [openTrackingDrawer, setOpenTrackingDrawer] = useState(false);
  const [currentRegulationTab, setCurrentRegulationTab] = useState(0);
  const [OpenDrawerImagineDocuments, setOpenDraweImagineDocuments] = useState(
    false,
  );
  const [expandRow, setExpandRow] = useCollapse(
    get(props.listings, 'managerInboxes', []),
  );
  useEffect(() => {
    if (
      featureService.hasFeature(FEATURES.TRAITEMENT_IMAGINE_DOC) &&
      !isNil(get(props.claimRecap, 'claim.claimNumber'))
    ) {
      props.requestGetPendingTasksClaim({
        claimNumber: get(props.claimRecap, 'claim.claimNumber'),
      });
    }
  }, [props.claimRecap]);

  const handleToggleTrackingDrawer = () => {
    setOpenTrackingDrawer(!openTrackingDrawer);
  };

  const getClaimNumber = () => {
    const claim = get(props.claimRecap, 'claim', {});
    return get(claim, 'claimNumber', '');
  };

  const handleClose = () => {
    props.setOpenFeeNoteDialog(false);
  };

  const toggleDrawer = () => {
    setDrawerOpen(!isDrawerOpen);
  };

  const handleToggleDrawer = () => {
    setOpenDraweImagineDocuments(!isDrawerOpen);
  };
  const tabs = {
    SUMMARY: {
      id: 0,
      title: translate(messages.courtManagerRecapTitle, props),
      feature: true,
    },

    PROVISION_AND_REGULATION: {
      id: 1,
      title: translate(messages.provisionTab, props),
      feature: featureService.hasFeature(FEATURES.PROVISION),
    },
  };
  const { currentTabIndex, labels = [] } = {
    currentTabIndex: claimTabs(tabs)?.currentTabIndex,
    labels: claimTabs(tabs)?.labels,
  };
  return (
    <Container>
      {get(props.claimRecap['claim'], ['suspicious']) &&
        featureService.hasFeature(FEATURES.FRAUDE_CORPO) && <SuspiciousCard />}
      <TopCard
        claimNumber={getClaimNumber()}
        claimRecap={props.claimRecap}
        sagisClaim={props.sagisClaim}
        inputProps={{ disableUnderline: true }}
        intl={props.intl}
        setDropDown={setDropDown}
        dropDown={dropDown}
        toggleDrawer={toggleDrawer}
        handleOpenCivilProceeding={() => {}}
        handleOpenDisclaimerWarrantyReasons={() => {}}
        requestSagisClaimInfo={props.requestSagisClaimInfo}
        toggleDrawerAssignmentClaim={() => {}}
        toggleAddVictimCard={() => {}}
        assignedLawyer={get(
          props.claimRecap,
          'claim.assignment[0].assignedLawyer',
        )}
        shouldHideActionButton={true}
        setIsAssignmentDialogOpen={() => {}}
        setOpenIsSuspiciosClaimDialog={() => {}}
        handleToggleImagineDocDrawer={handleToggleDrawer}
        resetSagisInfoClaim={() => {}}
        claimHasCivilPartyJudiciaryProcess={{}}
        handleToggleTrackingDrawer={handleToggleTrackingDrawer}
        requestSetStatusClaimSagis={props.requestSetStatusClaimSagis}
        isConsultation={false}
        listings={props.listings}
        handleResetStore={() => {}}
      />
      {featureService.hasFeature(FEATURES.TRACKING_ACTIONS_USER) && (
        <TrackingActionDrawer
          isDrawerOpen={openTrackingDrawer}
          setIsDrawerOpen={handleToggleTrackingDrawer}
          userActions={props.userActions}
          listings={props.listings}
          claimHistorySagis={props.claimHistorySagis}
          claimNumber={get(props.claimRecap, 'claim.claimNumber')}
          claimId={props.match.params.claimId}
          requestGetClaimHistoryActions={props.requestGetClaimHistoryActions}
          requestGetClaimHistorySagis={props.requestGetClaimHistorySagis}
          loaders={props.loaders}
        />
      )}
      {featureService.hasFeature(FEATURES.TRAITEMENT_IMAGINE_DOC) && (
        <ImagineDocumentsDrawer
          isDrawerOpen={OpenDrawerImagineDocuments}
          setIsDrawerOpen={setOpenDraweImagineDocuments}
          listings={props.listings}
          expandRow={expandRow}
          setExpandRow={setExpandRow}
          claimSagisInfo={resolveSagisClaim(props.policyInfo)}
          managerNotifcationsInboxes={get(
            props.pendingTasksClaim,
            'pendingNotifications',
            [],
          )}
          claimId={get(props.claimRecap, 'claim.id')}
          requestMakeDecisionsDocumentImaging={
            props.requestMakeDecisionsDocumentImaging
          }
          claimNumber={getClaimNumber()}
          requestGetNotificationsInboxes={props.requestGetNotificationsInboxes}
          isConsultation={false}
          imagineNotification={props.imagineNotification}
          shouldDisplayUploadDocument={false}
          requestUploadDocumentManager={props.requestUploadDocumentManager}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        />
      )}
      {featureService.hasFeature(FEATURES.FEE_NOTE) &&
        !isEmpty(props.feeNotes) && (
          <DialogFeeNote
            allFeeNote={props.allFeeNote}
            requestAllFeeNotes={props.requestAllFeeNotes}
            feeNotes={filterFeeNotes(props.feeNotes, false, {}, false)}
            feeNotesCount={props.feeNotesCount}
            requestLawyerFeeNotes={props.requestFeeNotesByClaimNumb}
            requestCreateFeeNote={props.requestCreateFeeNote}
            requestFeeNoteCosts={props.requestFeeNoteExceptionalCosts}
            keyclokToken={null}
            resetUploadDocumentStore={
              props.resetUploadDocumentStore
                ? props.resetUploadDocumentStore
                : () => {}
            }
            uploadDocument={
              props.uploadDocument ? props.uploadDocument : () => {}
            }
            uploadedDocument={props.uploadedDocument}
            setDocumentId={props.setDocumentId ? props.setDocumentId : () => {}}
            documentId={props.documentId}
            makeDecisionFeeNote={props.makeDecisionFeeNote}
            open={props.openFeeNoteDialog}
            handleClose={handleClose}
            showButtonAdd={false}
            title={translate(messages.FeeNoteTitle, props)}
            claimNumber={get(props.claimRecap, 'claim.claimNumber')}
            listings={props.listings}
            page={0}
            setPage={() => {}}
            linkToBeneficiaryCodes={props.linkToBeneficiaryCodes}
            isExpert={false}
            requestUpdateFeeNoteAmount={props.requestUpdateFeeNoteAmount}
            loaders={props.loaders}
            requestAddInvoiceFeeNote={props.requestAddInvoiceFeeNote}
            requestUpdateInvoiceFeeNote={props.requestUpdateInvoiceFeeNote}
            requestUpdateFeeNoteStatus={props.requestUpdateFeeNoteStatus}
            contractorFeesSagis={[]}
            isConsultation={false}
            requestUpdateFirmReferenceManager={
              props.requestUpdateFirmReferenceManager
            }
          />
        )}
      <div style={{ marginTop: 20 }}>
        <GlobalLegalProceedingTabs
          currentTabIndex={currentTabIndex}
          labels={labels}
          setCurrentInstanceTab={props.setCurrentInstanceTab}
        >
          <ClaimRecap {...props} />

          {get(tabs['PROVISION_AND_REGULATION'], 'feature', false) && (
            <main>
              <LegalProceedingTabs
                labels={PROVISION_TAB_LABELS}
                currentTabIndex={0}
              >
                <ProvisionContainer
                  claimNumber={getClaimNumber()}
                  listings={props.listings}
                  requestSagisClaimInfo={props.requestSagisClaimInfo}
                  sagisClaim={props.sagisClaim}
                  setIsDetail={() => {}}
                  requestValidateProvisionIntervenant={
                    props.requestValidateProvisionIntervenant
                  }
                  requestCreateStakeHolder={props.requestCreateStakeHolder}
                  claimId={get(props.claimRecap, 'claim.id')}
                  isConsultation={false}
                  lossDate={get(props.claimRecap, 'claim.lossDate')}
                  uploadedDocument={props.uploadedDocument}
                  resetUploadDocumentStore={
                    props.resetUploadDocumentStore
                      ? props.resetUploadDocumentStore
                      : () => {}
                  }
                  uploadDocument={
                    props.uploadDocument ? props.uploadDocument : () => {}
                  }
                  requestCreateFeeNoteManager={
                    props.requestCreateFeeNoteManager
                  }
                />
                <LegalProceedingTabs
                  labels={['Historiques']}
                  currentTabIndex={currentRegulationTab}
                  setCurrentInstanceTab={setCurrentRegulationTab}
                >
                  <Grid>
                    <RegulationRecapContainer
                      sagisClaim={props.sagisClaim}
                      listings={props.listings}
                      regulations={props.regulations}
                      isConsultation={true}
                      claimId={props.match.params.claimId}
                    />
                  </Grid>
                  <Grid></Grid>
                </LegalProceedingTabs>
              </LegalProceedingTabs>
            </main>
          )}
        </GlobalLegalProceedingTabs>
      </div>
    </Container>
  );
};

export default ValidatedRecapClaim;
